export default __webpack_public_path__ + "static/media/friendometerThumbnail.7ebd9adf.png";